import template from './tab-content.html';

const mapStateToThis = ({ session }) => {
  const { locale } = session;

  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class TabContentController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.onLanguageSelect(this.locale);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onLanguageSelect(locale) {
    // TODO: fix language select
  }
}

export default class TabContentComponent {
  constructor() {
    this.template = template;
    this.controller = TabContentController;
    this.bindings = {
      templates: '<',
      loaded: '<',
      model: '<',
      api: '<',
      namespace: '<',
      moduleName: '@',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/components/email-notification-tab/components/tab-content/tab-content-component.js